import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b90ac95"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "updateFolderModal",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "updateFolderModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title text-white" }, "Update Folder", -1))
const _hoisted_6 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_7 = { class: "text-danger" }
const _hoisted_8 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, "Folder Name", -1))
const _hoisted_11 = {
  key: 2,
  class: "modal-footer"
}
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-close-white",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
            ref: "closeBtn"
          }, null, 512)
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, " Error: " + _toDisplayString(_ctx.error), 1),
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
              }, "Reset")
            ]))
          : _createCommentVNode("", true),
        (!_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "name",
                  placeholder: "SSL Europe",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event)),
                  onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.name]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary ms-2",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
                disabled: _ctx.isDisabled
              }, _toDisplayString(_ctx.submitted ? "Updating" : "Update"), 9, _hoisted_12)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}